<template>
  <div>
    <GridComponent
      id="personList"
      ref="_grid"
      :data-source="_dataManager"
      :allow-paging="true"
      :allow-sorting="true"
      width="auto"
      :allow-reordering="true"
      :allow-resizing="true"
      :show-column-menu="false"
      :allow-text-wrap="true"
      :row-selected="onRowSelected"
      :row-deselected="onRowDeselected"
      :page-settings="_pageSettings"
      :action-failure="gridActionFailure"
      :selection-settings="selectionOptions"
    >
      <ColumnsDirective>
        <ColumnDirective
          type="checkbox"
          width="45"
        />
        <ColumnDirective
          header-text=""
          :template="'cTemplate'"
          width="28"
          :allow-sorting="false"
        >
          <template #cTemplate="{data}">
            <SogIcon
              v-show="data.vehicleRegistrationId"
              icon="mdi-car"
            />
            <SogIcon
              v-show="data.hasCancellationSupplier||data.hasCancellationPerson"
              icon="mdi-close"
              class="cl"
            />
          </template>
        </ColumnDirective>
        <ColumnDirective
          field="insuranceNumber"
          header-text="VSNR"
          :auto-fit="true"
        />
        <ColumnDirective
          field="grossPrice"
          header-text="Prämie, €"
          :auto-fit="true"
          format="n2"
          type="number"
        />
        <ColumnDirective
          field="createDate"
          header-text="Bestelldatum"
          :auto-fit="true"
          format="dd.MM.yyyy HH:mm:ss"
          type="dateTime"
        />
        <ColumnDirective
          field="evb"
          header-text="eVB/Form.Nr."
          :auto-fit="true"
          :value-accessor="calcEvb"
        />
        <ColumnDirective
          field="activationDate"
          header-text="Aktivierungsdatum"
          :auto-fit="true"
          format="dd.MM.yyyy HH:mm:ss"
          type="dateTime"
        />
        <ColumnDirective
          field="evbValidityDate"
          header-text="Gültig bis"
          :auto-fit="true"
          format="dd.MM.yyyy"
          type="dateTime"
        />
        <ColumnDirective
          field="productDescription"
          header-text=""
          :auto-fit="true"
          :allow-sorting="false"
        />
        <ColumnDirective
          field="manufacturerName"
          header-text="Versicherer"
          :auto-fit="true"
          :allow-sorting="false"
        />
      </ColumnsDirective>
    </GridComponent>
  </div>
</template>

<script setup lang="ts">
import {ref} from "vue";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import SogIcon from "@/shared/ui/SogIcon.vue";
import {Api, gridActionFailure} from "@/shared/services/api";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import Insurance from "@/shared/model/Insurance";
import {useNavigationStore} from "@/modules/Navigation/store";

interface Props {
  id?: string
  selected?: (array: Insurance[]) => void;
}

const props = withDefaults(defineProps<Props>(), {
    id: undefined,
    isSelected: undefined,
    selected: undefined
  }
)

const _emit = defineEmits<{ (e: 'selected', data?: any): void }>()


/*
const  _filterSettings = { type: 'Excel' }  //Menu CheckBox FilterBar Excel
*/


const _url = Api.baseUrl + '/InsuranceList';
const _navigationStore = useNavigationStore()

const _adaptor = new CustomAdaptor()

const _dataManager = ref<DataManager | undefined>()

const _dataManager1 = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})

const _grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}
const selectionOptions = {type: 'Multiple', checkboxOnly: false, enableToggle: true}

function onRowSelected(args: any) {
  _navigationStore.currentInsuranceId = args?.data?.id
  _navigationStore.currentInsuranceNumber = args?.data?.insuranceNumber
  _emit("selected", args.data)
  onSelected()
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _navigationStore.currentInsuranceId = undefined
  _navigationStore.currentInsuranceNumber = undefined
  _emit("selected", undefined)
  onSelected()
}

function onSelected() {
  if (props.selected) {
    const list = _grid.value?.getSelectedRecords()?.map(t => t as Insurance);
    props.selected(list ?? [])
  }
}

function refresh() {
  if (!_dataManager.value) {
    _dataManager.value = _dataManager1
  }

  _grid.value?.refresh()
}

function calcEvb(field: string, data: any) {
  const form = data['formNumber'] ?? ""
  const evb = data[field] ?? ""
  return (evb && evb !== "null") ? evb : "" + (form && form !== "null") ? form : ""
}

defineExpose({
  adaptor: _adaptor, refresh
})
</script>

<style scoped>

.cl {
  color: #ff0000;
}

</style>
